import { T } from "@classdojo/web";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";
import mojoLisaImage from "src/pods/conundrums/assets/mojoLisaFull.png";
import mojoLisaMad from "src/pods/conundrums/assets/mojoLisaMad.png";
import mojoLisaPaint from "src/pods/conundrums/assets/mojoLisaPaint.png";
import mojoLisaVisit from "src/pods/conundrums/assets/mojoLisaVisit.png";

export const Title = "Mojo Lisa";
export const Description = "Mojo purchased the Mona Lisa, and wants to paint over it!";
export const QuestionText = "Is this okay?";

const activities: Slide[] = [
  IntroSlide(Title, Description, QuestionText, mojoLisaImage, {}),
  ExpectationsSlide(),
  DescriptionSlide(
    "The Mona Lisa is 500 years old, and is the most famous painting in the world! Every year, thousands of people travel to Paris to see it.",
    mojoLisaVisit,
  ),
  DescriptionSlide(
    "Somehow, Mojo bought the Mona Lisa - and he wants to paint over it, to look like himself!",
    mojoLisaPaint,
  ),
  OptionsSlide("Should Mojo be allowed to paint the Mona Lisa?", [
    { option: "Yes, because..." },
    { option: "No, because..." },
  ]),
  DescriptionSlide("\"If I can't alter the painting, I'll just DESTROY it!\"", mojoLisaMad),
  OptionsSlide(
    <div>
      <T
        htmlStr="dojo.toolkit:definition.should_mojo_be"
        fallback="Should Mojo be allowed to <i>destroy</i> the Mona Lisa?"
      />
    </div>,
    [{ option: "Yes, because..." }, { option: "No, because..." }],
  ),
  PairShareSlide(
    "Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?",
  ),
  ShareToStorySlide(
    "Congrats on completing this Conundrum!",
    "Now that was an interesting question indeed.",
    "https://static.classdojo.com/img/mojoLisaShare.png",
    "Great discussion!",
  ),
];

export default activities;
